export const ContainerStyle = {
  baseStyle: {
    centerContent: true,
    maxW: 'md',
  },
};
